import { render, staticRenderFns } from "./ContactData.vue?vue&type=template&id=9516562a"
import script from "./ContactData.js?vue&type=script&lang=js&external"
export * from "./ContactData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports